import React, { useEffect, useRef, useState } from 'react';
import CategoryListCarousel from '../carouselSection/CategoryListCarousel';
import CategoryPdfCarousel from '../carouselSection/CategoryPdfCarousel';
import { isMobile } from 'react-device-detect';

export default function CategoryList({ data, colors }) {
    const [activeCategory, setActiveCategory] = useState("")
    const [desktopImageLoaded, setDesktopImageLoaded] = useState(false);
    const [mobileImageLoaded, setMobileImageLoaded] = useState(false);
    
    const handleActiveProduct = (data) => {
        setActiveCategory(data)
        setDesktopImageLoaded(false); // Reset desktop image loaded state when category changes
        setMobileImageLoaded(false); // Reset mobile image loaded state when category changes
    }

    // Reset image loaded states when activeCategory changes
    useEffect(() => {
        setDesktopImageLoaded(false);
        setMobileImageLoaded(false);
        
        // Preload the image if it exists
        if (activeCategory?.microsite_img) {
            const img = new Image();
            img.onload = () => {
                setDesktopImageLoaded(true);
                setMobileImageLoaded(true);
            };
            img.onerror = () => {
                setDesktopImageLoaded(false);
                setMobileImageLoaded(false);
            };
            img.src = activeCategory.microsite_img;
        }
    }, [activeCategory?.microsite_img]);

    return (
        <div className='lg:max-w-7xl mx-auto px-0'>
             <style>
                        {`
                            .gradient-blue {
                                background: linear-gradient(${colors?.primary}, ${colors?.primary});
                                -webkit-background-clip: text;
                                -webkit-text-fill-color: transparent;
                                line-height: normal;
                            }
                            
                            .country-customize input:focus{
                                border-color: ${colors?.secondary};
                            }
                            .custom_ring_color:focus {
                                border-color: ${colors?.secondary};
                                --tw-ring-color: ${colors?.secondary};
                            }
                        

                        `}
                    </style>
            <h1 style={{ color: colors?.primary }} className='text-3xl text-left mb-4 font-semibold'>Products</h1> 
            <div className='flex pr-4 text-left items-center'>
                <div className='w-[35%] max-sm:hidden bg-[#f0f0f0] rounded-t-3xl px-4 pr-0 border-b-4' style={{ borderColor: colors?.primary, backgroundColor: `${colors?.primary}10` }}>
                    <div className='flex justify-between items-center h-52 rounded-2xl'>
                        <div className='space-y-2 p-2 px-2'>
                            <span style={{ backgroundColor: `${colors?.primary}20`, color: colors?.primary }} className="inline-flex gap-1 rounded-md px-2 py-1 text-xs">
                                {activeCategory?.cat_name}
                            </span>
                            <h2 style={{ color: colors?.primary }} className='text-[20px]'>
                                { activeCategory?.title }
                            </h2>
                            <p style={{ color: colors?.textMuted }} className='text-xs'>
                                { activeCategory?.description?.slice(0,150) }{ activeCategory?.description?.length > 150 ? "...":"" }
                            </p>
                        </div>
                        <img 
                            src={activeCategory?.microsite_img && desktopImageLoaded ? activeCategory?.microsite_img : "https://salespanda.com/client/pdf/unnamed.jpg"} 
                            className='rounded-tr-3xl h-full w-40' 
                            alt='p_img'
                            onLoad={() => {
                                if (activeCategory?.microsite_img) {
                                    setDesktopImageLoaded(true);
                                }
                            }}
                            onError={(e) => {
                                e.target.src = "https://salespanda.com/client/pdf/unnamed.jpg";
                                setDesktopImageLoaded(false);
                            }}
                        />
                    </div>
                </div>
                <div className={`w-[65%] max-sm:w-full pl-6 max-sm:pl-0 ${isMobile ? (data?.length < 4 ?"product-carousel":"") : (data?.length < 5 ?"product-carousel":"") }`}>
                    <CategoryListCarousel data={data} handleActiveProduct={handleActiveProduct} colors={colors} />
                </div>
            </div>
            <div className='w-full hidden max-sm:block mt-4 text-left bg-[#f0f0f0] border-b-4 border-[#2167a7] rounded-t-3xl px-4 pr-0'>
                <div className='flex justify-between items-center h-52 max-sm:h-36 rounded-2xl'>
                    <div className='space-y-2 p-2 px-2'>
                        <span className="inline-flex bg-[#2167A720] gap-1 rounded-md text-[#2167A7] text-xs not-italic font-medium leading-4 items-center px-2 py-1">
                            {activeCategory?.cat_name}
                        </span>
                        <h2 className='text-[#2167A7] text-[20px] not-italic font-semibold leading-[132%] text-left capitalize'>{ activeCategory?.title }</h2>
                    </div>
                    <img 
                        src={activeCategory?.microsite_img && mobileImageLoaded ? activeCategory?.microsite_img : "https://salespanda.com/client/pdf/unnamed.jpg"} 
                        className='rounded-tr-3xl h-full w-32' 
                        alt='p_img'
                        onLoad={() => {
                            if (activeCategory?.microsite_img) {
                                setMobileImageLoaded(true);
                            }
                        }}
                        onError={(e) => {
                            e.target.src = "https://salespanda.com/client/pdf/unnamed.jpg";
                            setMobileImageLoaded(false);
                        }}
                    />
                </div>
            </div>
            <CategoryPdfCarousel activeData={activeCategory} colors={colors} />
        </div>
    );
}

